module.exports = __webpack_public_path__ + "barber-model-a40bd2.webp";